import { Layout } from 'plotly.js';
import { ThresholdLimits } from './interface';

export interface ColDict {
  [key: string]: number[];
}

export const plotConfig: any = {
  responsive: true,
  displayModeBar: true,
  autosizable: true,
  modeBarButtons: [['zoom2d', 'pan3d', 'autoScale2d', 'toImage']],
  displaylogo: false,
};
export const plotStyle = { width: '100%', height: '100%' };

export const plotlyPrecipitationMargin = {
  l: 10,
  // r: 0,
  b: 32,
  t: 32,
};
export const plotlyMargin = {
  l: 20,
  // r: 0,
  b: 29,
  t: 35,
};
export const plotlyTHPMargin = {
  l: 50,
  // r: 15,
  b: 40,
  t: 30,
  // t: 15,
  // pad: 4,
};
export const commonLegend = {
  y: 0.9,
};

export const plotlyFont = {
  family: '"Open Sans", verdana, arial, sans-serif',
  size: 10,
  color: '#252834',
};

export const chartWatermarkConfigs = [
  {
    x: 0.02,
    y: 0.92,
    sizex: 0.18,
    sizey: 0.18,
    xanchor: 'left',
    yanchor: 'top',
    layer: 'below',
    source:
      'data:image/png;base64,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',
  },
];

export const staticPlotlyChartLayout = () => {
  return {
    xaxis: { hoverformat: '%d-%m-%Y %H:%M UTC' },
    yaxis: { hoverformat: '.3r', automargin: true },
    margin: plotlyMargin,
    font: plotlyFont,
    shapes: [], // will be updated with threshold limits from modal
    // annotations: [], // will be updated with threshold limits from modal
    polar: {
      barmode: 'overlay',
      bargap: 0,
      angularaxis: {
        ticklen: 10,
        color: '#252834',
        direction: 'clockwise',
      },
      radialaxis: {
        angle: 0,
        tickcolor: '#252834',
        tickwidth: 1,
        tickangle: 0,
        ticklen: 3,
        fixedrange: true,
        tickmode: 'auto',
        nticks: 4,
        tickfont: {
          family: 'Open Sans',
          size: 10,
        },
      },

      // margin: {
      //   l: 0,
      //   r: 0,
      //   b: 0,
      //   t: 0,
      //   pad: 0,
      // },
    },
    responsive: true,
    autosize: true,
    // dragmode: false,
    legend: commonLegend,
    images: chartWatermarkConfigs,
  };
};

export const defaultPlotlyChartLayout = (unit?: string) => {
  return unit
    ? {
        ...staticPlotlyChartLayout(),
        yaxis: { title: unit, automargin: true, hoverformat: '.3r' },
      }
    : staticPlotlyChartLayout();
};

export const defaultWindLayout = {
  xaxis: { hoverformat: '%d-%m-%Y %H:%M UTC' },
  margin: plotlyTHPMargin,
  font: plotlyFont,
  grid: { rows: 2, columns: 1 },
  yaxis: {
    title: {
      text: 'Wind Speed (m/s)',
      standoff: 1,
    },
    showline: true,
    automargin: true,
  },
  yaxis2: {
    title: {
      text: 'Wind Direction (°)',
      standoff: 1,
    },
    tickvals: [0, 90, 180, 270, 360],
    ticktext: ['0\tN', '90\tE', '180\tS', '270\tW', '360\tN'],
    range: [0, 360],
    showline: true,
    automargin: true,
  },
  legend: commonLegend,
};

// Function to create a threshold line shape
export const createThresholdLine = (
  thresholdLabel: string,
  thresholdValue: number,
  color = 'gray',
): any => ({
  type: 'line',
  xref: 'paper',
  yref: 'y',
  x0: 0,
  x1: 1,
  y0: thresholdValue,
  y1: thresholdValue,
  name: thresholdLabel,
  line: {
    color,
    width: 2,
    dash: 'dash',
  },
});

export const addAnnotationsIfNeeded = (
  layout: Layout | any,
  threshold: ThresholdLimits,
  isThresholdHidden: boolean,
) => {
  if (
    !layout.annotations ||
    (threshold.thresholds.lowerThreshold.value === null &&
      threshold.thresholds.upperThreshold.value === null)
  ) {
    layout.annotations = [];
  }
  if (typeof threshold.thresholds.lowerThreshold.value === 'number') {
    layout.annotations[0] = {
      x: 1,
      y: threshold.thresholds.lowerThreshold.value,
      xref: 'paper',
      yref: 'y',
      text: threshold.thresholds.lowerThreshold.title || '',
      showarrow: false,
      ax: 0,
      ay: 0,
      visible: isThresholdHidden,
      yanchor: 'bottom',
      layer: 'above',
      font: {
        size: 12,
      },
      bgcolor: 'rgba(255, 255, 255, 0.8)',
    };
  }
  if (typeof threshold.thresholds.upperThreshold.value === 'number') {
    layout.annotations[1] = {
      x: 1,
      y: threshold.thresholds.upperThreshold.value,
      xref: 'paper',
      yref: 'y',
      text: threshold.thresholds.upperThreshold.title || '',
      showarrow: false,
      ax: 0,
      ay: 0,
      visible: isThresholdHidden,
      yanchor: 'bottom',
      layer: 'above',
      font: {
        size: 12,
      },
      bgcolor: 'rgba(255, 255, 255, 0.8)',
    };
  }
};
export const colDict: ColDict = {
  // total volatile organic compounds
  TVOC: [255, 201, 39],
  // nitrogen
  NO: [252, 129, 129],
  'NO(μg/m³)': [252, 129, 12],
  NO2: [197, 48, 48],
  'NO₂(μg/m³)': [197, 48, 48],
  // particulate
  particulatePM1: [141, 165, 237],
  'PM1(μg/m³)': [30, 105, 255],
  particulatePM25: [65, 105, 225],
  'PM2.5(μg/m³)': [65, 105, 225],
  particulatePM10: [0, 0, 139],
  'PM10(μg/m³)': [0, 0, 139],
  PM1: [141, 165, 237],
  PM25: [65, 105, 225],
  PM10: [0, 0, 139],
  // carbon
  CO: [107, 70, 193],
  'CO(mg/m³)': [107, 70, 193],
  CO2: [68, 51, 122],
  CH4: [183, 148, 244],
  C6H6: [233, 216, 253],
  // ozone
  O3: [0, 181, 216],
  'O₃(μg/m³)': [0, 181, 216],
  // sulphur
  SO2: [246, 173, 85],
  'SO₂(μg/m³)': [246, 173, 85],
  H2S: [192, 86, 33],
  'H₂S(μg/m³)': [192, 86, 33],
  // Amonia
  NH3: [56, 161, 105],
  // others
  Temperature: [255, 45, 85],
  Humidity: [255, 149, 0],
  tempC: [255, 45, 85],
  ambPressure: [13, 129, 254],
  ambHumidity: [255, 149, 0],
};

export const getAnnotations = (
  thresholdProp: { value: number; title: string },
  visible: boolean,
) => {
  return {
    x: 1,
    y: thresholdProp.value,
    xref: 'paper',
    yref: 'y',
    text: thresholdProp.title || '',
    showarrow: false,
    ax: 0,
    ay: 0,
    visible,
    yanchor: 'bottom',
    layer: 'above',
    font: {
      size: 12,
    },
    bgcolor: 'rgba(255, 255, 255, 0.8)',
  };
};

export const sourceApportionmentPalette = {
  NO2: ['#c53030', '#d66e6e', '#e29797', '#eec1c1', '#f8d5d5'],
  particulatePM25: ['#4169e1', '#7a96ea', '#a0b4f0', '#c6d2f6', '#d5defb'],
};
